// Selector de material — dropdown buscable, accesible.
//
// Uso:
//   const picker = materialPicker({
//     value: 'Pladur',
//     options: ['Pladur', 'Parquet', 'Cristal'],
//     onChange: (next) => { ... },
//   });
//   row.appendChild(picker);

export function materialPicker({ value, options, onChange, label }) {
  const wrap = document.createElement('div');
  wrap.className = 'picker';
  if (label) wrap.setAttribute('aria-label', label);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'picker__button';
  button.setAttribute('aria-haspopup', 'listbox');
  button.setAttribute('aria-expanded', 'false');
  button.textContent = value || 'Selecciona…';

  const panel = document.createElement('div');
  panel.className = 'picker__panel';
  panel.style.display = 'none';
  panel.setAttribute('role', 'listbox');

  const search = document.createElement('input');
  search.type = 'search';
  search.className = 'picker__search';
  search.placeholder = 'Buscar…';
  search.setAttribute('aria-label', 'Buscar material');
  panel.appendChild(search);

  const list = document.createElement('div');
  panel.appendChild(list);

  function renderOptions(filter = '') {
    list.innerHTML = '';
    const f = filter.trim().toLowerCase();
    const filtered = options.filter((o) => !f || o.toLowerCase().includes(f));
    for (const opt of filtered) {
      const item = document.createElement('div');
      item.className = 'picker__option';
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', String(opt === value));
      item.textContent = opt;
      item.addEventListener('click', () => {
        value = opt;
        button.textContent = opt;
        close();
        if (typeof onChange === 'function') onChange(opt);
      });
      list.appendChild(item);
    }
    if (!filtered.length) {
      const empty = document.createElement('div');
      empty.className = 'picker__option';
      empty.textContent = 'Sin resultados';
      empty.style.color = 'var(--c-gray)';
      list.appendChild(empty);
    }
  }

  function open() {
    panel.style.display = 'block';
    button.setAttribute('aria-expanded', 'true');
    search.value = '';
    renderOptions('');
    setTimeout(() => search.focus(), 0);
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onKey, true);
  }
  function close() {
    panel.style.display = 'none';
    button.setAttribute('aria-expanded', 'false');
    document.removeEventListener('click', onDocClick, true);
    document.removeEventListener('keydown', onKey, true);
  }
  function onDocClick(e) {
    if (!wrap.contains(e.target)) close();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  button.addEventListener('click', () => {
    panel.style.display === 'none' ? open() : close();
  });
  search.addEventListener('input', (e) => renderOptions(e.target.value));

  wrap.appendChild(button);
  wrap.appendChild(panel);
  return wrap;
}
